<template>
    <div>
        <Card :title="$route.meta.title" dis-hover>
            <Row>
                <Col span="24">
                    <baidu-map ref="map" v-if="center!=null" :style="{width:map.width,height:map.height}"  class="map" ak="你的百度地图秘钥"
                               :center="center" :zoom="map.zoom" :scroll-wheel-zoom="true"
                               @mousemove="syncPolyline"
                               @click="paintPolyline"
                               @rightclick="finish" @ready="initDrawing">
                        <!--比例尺控件-->
                        <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
                        <!--缩放控件-->
                        <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" ></bm-navigation>
                        <bm-control v-if="dm!=null">
                            <Tag color="warning" size="large" v-show="drawing&&!confirmShow" @click="toggle('polyline')">鼠标左键点击绘制，双击结束</Tag>
                            <Button type="warning" size="large" v-show="!confirmShow&&!drawing" @click="rePaint('polyline')">开始绘制</Button>
                            <template v-if="confirmShow&&!drawing">
                                <Button type="warning" size="large" @click="confirmAdd">确认添加</Button>
                                <Button type="warning" size="large" @click="handleCancel" style="margin-left:10px;">取消</Button>
                                <Button type="warning" size="large" @click="overlay.disableEditing()" style="margin-left:10px;">取消编辑</Button>
                            </template>
                        </bm-control>
                        <bm-polygon :path="path" v-for="path of polyline.paths" stroke-color="red" fill-color="red" :stroke-opacity="0.8" :fill-opacity="0.6" :stroke-weight="3"></bm-polygon>
                        <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_LEFT" :showAddressBar="false" :autoLocation="true"></bm-geolocation>
                    </baidu-map>
                </Col>
            </Row>
        </Card>

        <Modal v-model="showAddInput" title="添加围栏" ok-text="添加新低排区" @on-ok="handleSubmit" @on-cancel="handleCancel">
            <Form style="">
                <FormItem label="低排区命名" prop="name"  >
                    <Input style="width:200px" v-model="name" placeholder="低排区命名"></Input>
                </FormItem>
                <!--<Button type="primary" @click="handleSubmit"></Button>-->
            </Form>
        </Modal>
    </div>
</template>
<!--<script src="http://api.map.baidu.com/api?v=2.0&ak=您的密钥"></script>
<script src="http://api.map.baidu.com/library/DrawingManager/1.4/src/DrawingManager_min.js"></script>-->
<script>
    import rules from '@/libs/rules';
    import iFence from '@/module/main/api/iFence';
    import iProperties from '@/module/base/api/iProperties';
    import _don from '@/libs/doson'
    //百度地图
    import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
    import BmScale from 'vue-baidu-map/components/controls/Scale'
    import BmControl from 'vue-baidu-map/components/controls/Control'
    import BmNavigation from 'vue-baidu-map/components/controls/Navigation'
    import BmGeolocation from 'vue-baidu-map/components/controls/Geolocation'
    import BmMarkerClusterer from  'vue-baidu-map/components/extra/MarkerClusterer'
    import BmPolygon from 'vue-baidu-map/components/overlays/Polygon'
    import BmPolyline from 'vue-baidu-map/components/overlays/Polyline'




    const modalFormTemplate = {
        id: null,
        name:null,
        endTime:null,
    };

    export default {
         name:'fence_draw',
         components:{
             BaiduMap,BmControl,BmPolygon,BmScale,BmNavigation,BmGeolocation,BmMarkerClusterer,BmPolyline
         },
        data () {
            return {
                rules:rules,
                name:null,
                polyline: {
                    editing: false,
                    paths: []
                },
                center:null,
                map:{
                    zoom:12,
                    //width:(document.body.clientWidth-300)+'px',
                    width:'100%',
                    height:(document.body.clientHeight-200)+'px',
                },
                dm:null,
                drawing:false,
                confirmShow:false,
                overlay:null,
                positions:null,
                showAddInput:false,
                editing:false
            }
        },
        mounted(){
            iProperties.getByProp('map_center').then(res => {
                var arr = res.value.split(',')
                this.center = {lng:parseFloat(arr[0]), lat:parseFloat(arr[1])}
            });
         },
        destroy() {
             this.dm = null
             this.overlay = null
             this.positions = null
        },
        methods: {
            initDrawing({BMap,map}) {
                var _th = this
                if (typeof(BMapLib) == 'undefined') {
                    const $script = document.createElement('script')
                    global.document.body.appendChild($script)
                    $script.onload = function () {
                        _th.initDm()
                    };
                    $script.src = '//api.map.baidu.com/library/DrawingManager/1.4/src/DrawingManager_min.js'
                } else {
                    _th.initDm()
                }
            },
            initDm() {
                var styleOptions = {
                    strokeColor:"red",    //边线颜色。
                    fillColor:"red",      //填充颜色。当参数为空时，圆形将没有填充效果。
                    strokeWeight: 3,       //边线的宽度，以像素为单位。
                    strokeOpacity: 0.8,    //边线透明度，取值范围0 - 1。
                    fillOpacity: 0.6,      //填充的透明度，取值范围0 - 1。
                    strokeStyle: 'solid' //边线的样式，solid或dashed。
                }
                //实例化鼠标绘制工具
                this.dm = new BMapLib.DrawingManager(this.$refs.map.map, {
                    isOpen: false, //是否开启绘制模式
                    enableDrawingTool: false, //是否显示工具栏
                    //drawingMode:DrawingType.BMAP_DRAWING_POLYGON ,
                    drawingMode:'polygon' ,
                    drawingToolOptions: {
                        anchor: BMAP_ANCHOR_TOP_RIGHT, //位置
                        offset: new BMap.Size(5, 5), //偏离值
                    },
                    polygonOptions: styleOptions, //多边形的样式
                });
                this.dm.addEventListener('overlaycomplete', this.overlaycomplete)
            },
            overlaycomplete(e) {
                this.drawing = false
                setTimeout(()=>{
                    this.confirmShow = true
                },500)
                let p = '';
                e.overlay.enableEditing()
                const path = e.overlay.getPath()
                path.forEach(i => {
                    p += (i.lng+','+i.lat+';')
                });
                path.length>0&&(p+=(path[0].lng+','+path[0].lat+';'))
                this.overlay = e.overlay
                this.positions = p

            },
            confirmAdd() {
                let p = '';
                const path = this.overlay.getPath()
                path.forEach(i => {
                    p += (i.lng+','+i.lat+';')
                });
                path.length>0&&(p+=(path[0].lng+','+path[0].lat+';'))
                this.positions = p
                this.showAddInput = true
            },
            toggle (name) {
                this[name].editing = !this[name].editing
            },
            rePaint (name) {
                //this[name].editing = !this[name].editing
                //this[name].paths = []
                this.overlay && (this.$refs.map.map.removeOverlay(this.overlay))
                this.positions && (this.positions = null)

                this.drawing = true
                this.dm.open()
            },
            syncPolyline (e) {
                if (!this.polyline.editing) {
                    return
                }
                const {paths} = this.polyline
                if (!paths.length) {
                    return
                }
                const path = paths[paths.length - 1]
                if (!path.length) {
                    return
                }
                if (path.length === 1) {
                    path.push(e.point)
                }
                this.$set(path, path.length - 1, e.point)
            },
            finish(e){
                this.polyline.editing = false;
                const {paths} = this.polyline
                const path = paths[paths.length - 1]
                path.pop()

                //自动合拢
                path.push(path[0])
                console.log(path)
            },
            newPolyline (e) {
                if (!this.polyline.editing) {
                    return
                }
                const {paths} = this.polyline
                if(!paths.length) {
                    paths.push([])
                }
                const path = paths[paths.length - 1]
                path.pop()
                if (path.length) {
                    paths.push([])
                }
            },
            paintPolyline (e) {
                if (!this.polyline.editing) {
                    return
                }
                const {paths} = this.polyline
                !paths.length && paths.push([])
                paths[paths.length - 1].push(e.point)
            },
            valData(){
                if(this.name == null || this.name.length<1){
                    this.$Modal.error({
                        title: '请为低排区命名',
                    })
                    return false;
                }
                /*let {paths} = this.polyline
                if(paths.length == 0){
                    this.$Modal.error({
                        title: '请点击"开始绘制"按钮，画出低排区域',
                    })
                    return false;
                }*/
                if(this.positions == null){
                    this.$Modal.error({
                        title: '请点击"开始绘制"按钮，画出低排区域',
                    })
                    return false;
                }
                return true;
            },
            handleSubmit(){
                if(this.valData()){
                    /*let positions = '';
                    let {paths} = this.polyline

                    paths[0].forEach(item=>{
                        positions = positions + (item.lng+','+item.lat)+';'
                    })*/
                    this.showAddInput = false
                    this.confirmShow = false
                    iFence.save({name:this.name,positions:this.positions}).then(res => {
                        this.$Modal.confirm({
                            title: '操作成功',
                            content: '低排区添加成功：'+this.name,
                            okText:'查看所有低排区',
                            cancelText:'继续添加',
                            onOk: () => {
                                this.$router.back();
                            }
                        });
                        this.$refs.map.map.removeOverlay(this.overlay)
                        this.name = null;
                        this.positions = null
                    });
                }

            },
            handleCancel() {
                this.$refs.map.map.removeOverlay(this.overlay)
                this.name = null;
                this.positions = null
                this.showAddInput = false
                this.confirmShow = false
            }
        }
    }
</script>

<style scoped lang="less">

    .fence_title{
        margin: 0 10px 0 0;
        display: flex;
        justify-content: space-between;
    }

    .fence_list{
        margin-left: 10px;
        display: flex;
        flex-direction: column;
        .fence_item{
            margin-right: 10px;
            display: flex;
            justify-content: space-between;
        }
    }
</style>
